<template>
  <div class="main-content">
    <h1 class="title">Soumyadip Hazra</h1>
    <h2 class="sub-heading">Front-End Software Engineer</h2>
    <ul class="header-contacts">
      <li>
        <i class="far fa-envelope"></i>
        soumyadiphazra@gmail.com
      </li>
      <li style="text-align: center;">
        <i class="fas fa-phone"></i>
        (91)-7797911115
      </li>
      <li>
        <i class="fa fa-globe"></i>
        soumyadiphazra.com
      </li>
      <li>
        <i class="fab fa-github"></i>
        github.com/soumyadip001
      </li>
    </ul>
    <div class="two-coloum-layout">
      <div class="col-1">

        <h3 class="section-heading">Relevant Experience</h3>
        <div>
          <h4>Programmer Analyst @Cognizant</h4>
          <h5>Oct 2018 - Present</h5>
          <p class="no-gutters">
            Worked with Retail domain, handling e-commerce website development and maintenance. Worked with various JavaScript frameworks like Node JS, Vue JS, Typescript, React, Redux. Also worked on Hybris UI, JSTL, GraphQL, Webpack, Dockers, Scss, Backbone JS, jQuery, HTML5, CSS3, Zen-desk etc.
          </p>
        </div>

        <div>
          <h4>Web Developer @ Unified Infotect Pvt Ltd.</h4>
          <h5>Apr 2016 - Oct 2018</h5>
        </div>

        <div>
          <h4>Jr PHP Developer @ Encoders technologies</h4>
          <h5>Sep 2015 - Mar 2016</h5>
        </div>

        <h3 class="section-heading">Project Works</h3>
        <div>
          <h4>Levi's Ecommerce</h4>
          <h5>Oct 2018 - Present</h5>
          <ul class="company-roles">
            <li>Mostly worked on Vue, VueX, GraphQL, Appolo, JavaScript, Node.js, Redis, etc</li>
            <li>Building FE architecture and designing rich UI followed with best practices such as SEO, Accessibility etc</li>
            <li>Project scoping, Unit testing, reviewing code, helping other associates</li>
          </ul>
        </div>

        <div>
          <h4>Gintaa</h4>
          <h5>June 2020 - Present</h5>
          <ul class="company-roles">
            <li>Write modern, performant, and robust code for a diverse array of client and internal projects</li>
            <li>Work with a variety of different languages, frameworks, and content management systems such as Angular, TypeScript, Material UI, SSR, Node.js, Firebase etc</li>
          </ul>
        </div>

        <div>
          <h4>Bitmarket PL</h4>
          <h5>2018</h5>
          <ul class="company-roles">
            <li>Engineered and maintained major features of Starry's customer-facing web app using ES6, PHP, Node, MongoDB, Twig, and CSS</li>
            <li>Worked closely with designers and management team to develop, document, and manage the website</li>
          </ul>
        </div>

      </div>
      <div class="col-2">
        <h3 class="section-heading">Skills</h3>
        <h4>Programming Languages</h4>
        <p class="language-worked-on">
          JavaScript (ES6), TypeScript, HTML,
          CSS/Sass, GraphQL, Python, R, PHP
        </p>

        <h4>Libraries & Frameworks</h4>
        <p class="language-worked-on">
          jQuery, React, Gatsby, Vue, Node.js,
          Express, Jekyll, Timber, NativeScript
        </p>

        <h4>Tools & Platforms</h4>
        <p class="language-worked-on">
          Git, Gulp, Webpack, Netlify, Heroku,
          Prismic, Contentful, Craft, Wordpress,
          Docker, Firebase
        </p>

        <h3 class="section-heading">Education</h3>
        <h4>College of Engg & Management, Kolaghat</h4>
        <h5>2011 - 2015</h5>
        <p class="language-worked-on">
          Bachelor of Computer Science from WBUT
        </p>

        <h4>Burdwan Town School</h4>
        <h5>2009 - 2011</h5>
        <p class="language-worked-on">
          Higher secondary education from WBCHSE
        </p>

        <h4>Kuchut P. C. Institution</h4>
        <h5>2009 - 2011</h5>
        <p class="language-worked-on">
          Secondary education from WBBSE
        </p>

        <h3 class="section-heading">Interests</h3>
        <p>
          Web Designing, Ethical Hacking, Traveling, Photography, Gaming
        </p>
      </div>
    </div>

    <div class="download-resume">
      <a href="index.html">
        <i class="fas fa-home"></i>
      </a>
      <a
        href="dist/resume-soumyadip-hazra-onepage.pdf"
        target="_blank"
        rel="noopener noreferrer"
        title="Download CV in pdf"
      >
        <i
          class="fas fa-file-pdf"
          role="presentation"></i>
      </a>
      <a
        href="dist/Soumyadip-Hazra-Resume.docx"
        title="Download CV in docx"
      >
        <i
          class="fas fa-file-word"
          role="presentation"></i> &nbsp;
        Download Original</a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Resume'
}
</script>

<style lang="scss" scoped>
@import "../assets/scss/pages/_resume.scss";
</style>
